var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"inspire"}},[(_vm.isSigned && _vm.$route.name !== 'How To')?_c(_vm.layout,{tag:"component"},[_c('router-view')],1):(_vm.$route.name !== 'How To')?_c('Login'):_c('HowTo')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }